module.exports = __webpack_public_path__ + "static/media/yellow_shape.25bf87fe.svg";